<template>
  <div class="notranslate">
    <div class="navUtils">
      <LanguageList v-if="isStore"
        :locale="locale" />
      <button v-if="callStaff && isValid"
        type="button"
        class="btn btnRequest"
        :style="getDefaultBtnStyle"
        @click.stop="setCallStaff">
        {{ locale.call_staff }}
      </button>
    </div>
    <button v-if="isAuth && canMyOrder"
      type="button"
      class="btn"
      :style="getDefaultBtnStyle"
      @click="showMypage">
      {{ locale.order_list }}
    </button>
    <button v-if="isAuth && !isTimeout"
      type="button"
      class="btn"
      :style="getDefaultBtnStyle"
      @click="showCart">
      {{ locale.cart }}
      <i v-if="cartCount" class="count" :style="getDefaultBtnStyleReverse">{{ cartCount }}</i>
    </button>
  </div>
</template>

<script>
import regExp from '@/common/regExp'
import LanguageList from '@/components/Util/LanguageList'

export default {
  name: 'shopNav',
  props: [
    'locale',
    'lang',
    'roomKey',
    'isPublic',
    'isAuth',
    // 'cartCount',
    'shopPageId'
  ],
  components: {
    LanguageList
  },
  computed: {
    isStore () {
      return this.$route.name === 'store'
    },
    shopPageSettings () {
      return this.$store.getters['shop/getShopSettings'](this.shopPageId)
    },
    cartCount () {
      const list = this.$store.getters['cart/getList'](this.isStore && this.shopPageId) || []
      const total = list.reduce((sum, item) => {
        const qty = (item.payload && item.payload.quantity && Number(item.payload.quantity || 1)) || 1
        return sum + qty
      }, 0)
      return total
    },
    cartList () {
      const list = this.$store.getters['cart/getList'](this.isStore && this.shopPageId) || []
      return list
    },
    getDefaultBtnStyle () {
      return this.$store.getters['common/getDefaultBtnStyle']
    },
    getDefaultBtnStyleReverse () {
      return this.$store.getters['common/getDefaultBtnStyleReverse']
    },
    callStaff () {
      const settings = this.shopPageSettings
      const useCallStaff = settings && settings.isUseCallStaff
      // return settings && settings.callStaff
      return useCallStaff && 'call-staff'
    },
    isValid () {
      const isAuth = this.$store.getters['authentication/isAuth']
      return this.roomKey ? true : isAuth
    },
    isTimeout () {
      const getShopTimeout = this.$store.getters['shop/getShopOrderTimeout'](this.shopPageId)
      return getShopTimeout
    },
    canMyOrder () {
      const settings = this.shopPageSettings
      return !(settings && settings.disabledMyOrder)
    },
  },
  data () {
    return {
    }
  },
  methods: {
    showMypage (e) {
      e.stopPropagation()
      e.preventDefault()
      this.$emit('showMypage')
    },
    showCart (e) {
      e.stopPropagation()
      e.preventDefault()
      this.$emit('showCart')
    },
    setCallStaff () {
      this.$store.commit('shop/setCallStaff', true)
    }
  }
}
</script>